import React from "react";

import MuiCheckbox from "@material-ui/core/Checkbox";

import { PaymentMethodChips } from "components/Chip";
import { DeploymentBusinessName } from "components/ClearingSaleCards/BusinessComponents";
import { Text } from "components/Text";

import { formatDollarsFromCents } from "lib";

import {
  BuyerSaleLotSummary,
  IndividualColumnReason,
  IndividualColumnReasonText,
  RoutingSide,
} from "./routing";
import { BuyerDetails, BuyerRow } from "./styles";

export function BuyerListRow({
  suggestion,
  side,
  isSelected,
  onToggleSelected,
  onMove,
  lotSummary,
  reasons,
}: {
  suggestion: AccountingDayRoutingSuggestion;
  side: RoutingSide;
  isSelected: boolean;
  onToggleSelected: (buyerId: string) => void;
  onMove: (buyerId: string) => void;
  lotSummary: BuyerSaleLotSummary;
  reasons: IndividualColumnReason[];
}) {
  const { lotCount, totalPaidCents, totalInvoiceCents } = lotSummary;
  const isFlaggedForReview =
    side === RoutingSide.Individual && suggestion.suggestCashAccount;
  const showReasons = side === RoutingSide.Individual && !isFlaggedForReview;

  const handleToggleSelected = () => onToggleSelected(suggestion.id);
  const handleMove = () => onMove(suggestion.id);

  return (
    <BuyerRow
      selected={isSelected}
      onClick={handleToggleSelected}
      onDoubleClick={handleMove}
    >
      <MuiCheckbox
        color="primary"
        checked={isSelected}
        onChange={handleToggleSelected}
        onClick={event => event.stopPropagation()}
      />
      <BuyerDetails>
        <DeploymentBusinessName businessId={suggestion.id} />
        <Text color="gray44" fontSize="alpha">
          {lotCount} sale lot{lotCount === 1 ? "" : "s"} &middot;{" "}
          {formatDollarsFromCents(totalInvoiceCents, { format: true })} bought
          &middot; {formatDollarsFromCents(totalPaidCents, { format: true })}{" "}
          paid
        </Text>
        <PaymentMethodChips buyerId={suggestion.id} small />
        {isFlaggedForReview && (
          <Text color="warningOrange" fontSize="alpha">
            Suggested: reassign to Cash Buyer
          </Text>
        )}
        {showReasons &&
          reasons.map(reason => (
            <Text key={reason} color="gray44" fontSize="alpha">
              {IndividualColumnReasonText[reason]}
            </Text>
          ))}
      </BuyerDetails>
    </BuyerRow>
  );
}
